import { Component, Input, EventEmitter, Output, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { Case } from 'src/app/services/case-manager.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { CaseManagerService } from '../../../services/case-manager.service';

@Component({
    selector: 'app-case-table',
    templateUrl: './case-table.component.html',
    styleUrls: ['./case-table.component.scss']
})
export class CaseTableComponent implements AfterViewInit, OnChanges {
    @Input() tableData: Case[];
    @Input() type: boolean;
    @Input() caseType: 'Pending' | 'Mine' = null;
    @Input() pageSize: number = 10;
    @Input() showPaginator;
    @Output() selectCase: EventEmitter<Case> = new EventEmitter();
    displayedColumns: string[] = ['customer_name', 'created_at', 'due_date', 'total_risk_score', 'status'];
    dataSource = new MatTableDataSource<Case>(this.tableData);
    selection = null;
    selectedRow: Case = null;


    resultsLength = 0;
    isLoadingResults = true;
    isRateLimitReached = false;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

    constructor(public caseManagerService: CaseManagerService) {
        this.selection = new SelectionModel<Case>(true, []);
    }

    ngAfterViewInit(): void {
      merge(this.sort.sortChange, this.paginator?.page)
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isLoadingResults = true;
            if (this.caseType === 'Pending') {
              return this.caseManagerService!.getPendingCases(this.paginator.pageIndex + 1);
            } else {
              return this.caseManagerService!.getAssignedCases(this.paginator.pageIndex + 1, this.pageSize);
            }
          }),
          map(data => {
            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            this.resultsLength = data.count ?? data.total;

            return data.results ?? data.data;
          }),
          catchError(() => {
            this.isLoadingResults = false;
            this.isRateLimitReached = true;
            return observableOf([]);
          })
        ).subscribe(data => {
          this.dataSource.data = data
        });
    }

    ngOnChanges() {
      this.dataSource = new MatTableDataSource<Case>(this.tableData);   
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }

    selectRow(row: Case) {
        this.selectCase.emit(row);
    }

  getElementStatus(status: number | string): string {
      switch (status) {
        case 'O':
          return 'Open';
        case 'C':
          return  'Closed';
        case 'OR':
          return 'Open and Reported';
        case 'CR':
          return 'Closed and Reported';
        case 'R':
          return  'Reopened';
        case 'AP':
          return 'Approved';
        case 'RJ':
          return 'Rejected';
      }
  }
}

